import React, { useEffect } from 'react';
import { Dispatch, forwardRef, useImperativeHandle, useState } from 'react';
import { Modal, Form, Button, Input, notification, Select } from 'antd';
import { loadRequest } from '../../../../../../../../store/ducks/agendamentos/actions';
import api from '../../../../../../../../service/api';
import { SKW_AUTH, SKW_PREFIX } from '../../../../../../../../utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../../store';
import { Action } from 'redux';
import TitlePage from 'components/TitlePage';
import {
  AgendamentoServices,
  ListaMotivo,
} from 'modules/agendamentos/submodules/agendamentos/services/AgendamentoServices';
import mask from 'utils/mask';

export interface PropsRefFinalizarAgendamento {
  showModal: () => void;
}
interface Props {
  codAgendamento: number;
}

const Finalizar: React.ForwardRefRenderFunction<PropsRefFinalizarAgendamento, Props> = (
  { codAgendamento },
  ref
) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const loading = useSelector((state: ApplicationState) => state.Ocorrencia.loading);
  const [modalFinalizarAgendamento, setModalFinalizarAgendamento] = useState(false);

  const dispatch = useDispatch<Dispatch<Action>>();
  const { Option } = Select;
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth.cddAtivo);
  const filter = useSelector((state: ApplicationState) => state.Agendamentos.filter);
  const [listaMotivos, setListaMotivo] = useState<ListaMotivo[]>([]);

  async function list() {
    await AgendamentoServices.listaMotivosCanAge().then((res) => {
      setListaMotivo(res.data?.motivos);
    });
  }
  useEffect(() => {
    list();
  }, []);

  const onFinish = async (values: { motivo: string; obs: string }) => {
    if (!values) {
      return notification.error({
        message: `Descreva o motivo`,
        placement: 'bottomRight',
      });
    }

    await api
      .post(
        `call?serviceName=${SKW_PREFIX}cancelarAgendamento&accessKey=${SKW_AUTH}&hasTransaction=true&token=${token}`,
        {
          codAgendamento: codAgendamento,
          codMotivo: values.motivo,
          obs: values.obs
        }
      )
      .then((res) => {
        notification.success({
          message: ` Agendamento cancelado`,
          description: `Agendamento nº${codAgendamento} cancelado com sucesso!`,
          placement: 'bottomRight',
        });
        setModalFinalizarAgendamento(false);
        dispatch(loadRequest(filter, inscricaoAtiva, cddAtivo?.codCdd));
      })
      .catch((err) => {
        notification.error({
          message: `Algo deu errado`,
          description: `Não foi possível cancelar o pedido ${codAgendamento}!`,
          placement: 'bottomRight',
        });
      });
  };

  useImperativeHandle(ref, () => ({
    showModal: () => {
      setModalFinalizarAgendamento(true);
    },
  }));

  return (
    <>
      <Modal
        width={800}
        title={<TitlePage>Cancelar o agendamento</TitlePage>}
        visible={modalFinalizarAgendamento}
        footer={[]}
        onCancel={() => setModalFinalizarAgendamento(false)}
      >
        <Form
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          wrapperCol={{ span: 24 }}
        >
          {
            <Form.Item
              label="Motivo"
              name="motivo"
              rules={[{ required: true, message: 'Por favor selecione o motivo do cancelamento' }]}
            >
              <Select placeholder="Selecione o motivo">
                {listaMotivos?.map((item) => (
                  <Option key={item?.cod} value={item?.cod}>
                    {mask('camelCase', item?.descricao)}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          }

          <Form.Item
            label="Observações"
            name="obs"
            rules={[{ required: true, message: 'Por favor selecione o motivo do cancelamento' }]}
          >
            <TextArea rows={7} placeholder="Digite aqui suas observações" />
          </Form.Item>
          <Form.Item style={{ alignItems: 'end' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              style={{ backgroundColor: '#FF4D4F', border: 'none' }}
            >
              Cancelar agendamento
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default forwardRef(Finalizar);
